import "animate.css";
import "./Dialog.scss";
import React from "react";

function Dialog({ children, className, onClose }) {
  return (
    <div className={"Dialog" + (className ? ` ${className}` : "")} onClick={e => e.stopPropagation()}>
      <div className="DialogHead">
        <div className="line"></div>
        <div className="close-button" onClick={e => onClose()} ><i className="icon-close" /></div>
      </div>
      <div className="DialogBody">
        {children}
      </div>
    </div>
  );
}

export default Dialog;